import FilterListIcon from "@material-ui/icons/FilterList";
import React, { ReactNode, useRef, useState } from "react";
import { Box, IconButton, Popover } from "@material-ui/core";
import { Form, Formik, FormikProps } from "formik";
import useStyles from "./TableColumnUserFilterStyles";
import { tesaBlue, tesaDarkGrey } from "../../../../../../../../styles/colors";
import { Field } from "../../../../../NotificationsDialog/interfaces/TableRowView";
import NotificationListAssignableUsersInput from "./NotificationListAssignableUsersInput";

interface FormField {
  id: number;
  name: string;
}
interface InnerFormikProps {
  users: FormField[];
}

interface TableColumnUserFilterProps {
  laboratoryId: number;
  activeFilters: Field[];
  popoverId: string;
  onFilterChange: (data: Field[]) => void;
}

const TableColumnUserFilter = (props: TableColumnUserFilterProps) => {
  const { laboratoryId, activeFilters, onFilterChange } = props;

  const classes = useStyles();

  const formRef = useRef<FormikProps<InnerFormikProps>>(null);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOnSubmit = () => {};

  const open = Boolean(anchorEl);

  const id = open ? props.popoverId : undefined;

  const [reset, setReset] = useState(false);

  return (
    <>
      <IconButton size="small" onClick={handleClick}>
        <FilterListIcon
          fontSize="inherit"
          style={activeFilters && activeFilters.length > 0 ? { color: tesaBlue } : { color: tesaDarkGrey }}
        />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box className={classes.box}>
          <Formik
            innerRef={formRef}
            enableReinitialize
            initialValues={{ users: activeFilters }}
            onSubmit={handleOnSubmit}
          >
            {(formikProps: FormikProps<InnerFormikProps>): ReactNode => {
              const { values, setFieldValue } = formikProps;

              return (
                <Form>
                  <NotificationListAssignableUsersInput
                    formRef={React.createRef()}
                    disabled={false}
                    laboratoryId={laboratoryId}
                    reset={reset}
                    handleSetReseting={setReset}
                    values={values}
                    setFieldValue={(field, value) => {
                      onFilterChange(value as unknown as Field[]);
                      setFieldValue(field, value);
                    }}
                  />
                </Form>
              );
            }}
          </Formik>
        </Box>
      </Popover>
    </>
  );
};

export default TableColumnUserFilter;
